module.exports = __webpack_public_path__ + "static/nxrt-automotive7-77dd3dd359f15c3b379ca7c5add2e946.jpg";